import {
  List,
  Datagrid,
  TextField,
  BooleanField,
  EditButton,
  DeleteButton,
  ReferenceField,
  NumberField,
  FunctionField,
} from 'react-admin';

export const CategoryList = () => (
  <List>
    <Datagrid>
      <FunctionField
        label="Image"
        render={(record: any) => {
          const image = record.image;
          if (!image) return null;
          
          // Use thumbnail if available, otherwise fallback to original
          const imageUrl = image.thumbnails?.find((t: any) => t.type === 'W550')?.url || image.url;
          
          return (
            <img 
              src={imageUrl} 
              alt={record.name} 
              style={{ maxWidth: 40, maxHeight: 40, objectFit: 'cover' }} 
            />
          );
        }}
      />
      <FunctionField
        label="Icon"
        render={(record: any) => {
          const icon = record.icon;
          if (!icon) return null;
          
          // Use thumbnail if available, otherwise fallback to original
          const iconUrl = icon.thumbnails?.find((t: any) => t.type === 'W550')?.url || icon.url;
          
          return (
            <img 
              src={iconUrl} 
              alt={record.name} 
              style={{ maxWidth: 30, maxHeight: 30, objectFit: 'cover' }} 
            />
          );
        }}
      />
      <TextField source="name" />
      <TextField source="slug" />
      <ReferenceField source="parentId" reference="categories" link="show" emptyText="Root Category">
        <TextField source="name" />
      </ReferenceField>
      <NumberField source="sortOrder" />
      <BooleanField source="isActive" />
      <EditButton />
      <DeleteButton mutationMode="pessimistic" />
    </Datagrid>
  </List>
);
